import { render, staticRenderFns } from "./DegreeView.vue?vue&type=template&id=b06d7204"
import script from "./DegreeView.vue?vue&type=script&lang=js"
export * from "./DegreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports